import { createContext, useContext } from 'react';
import { getPerfArms } from 'src/lib/perf/perfArms';
import { initialState } from 'src/providers/ModalsProvider/Modals.constants';
import { useModalsContext } from 'src/providers/ModalsProvider/Modals.context';
import type { tModalsContext } from 'src/providers/ModalsProvider/Modals.types';

type tPipeModalsSlice = Pick<tModalsContext,
  | 'messageReadFilter' | 'dateRange' | 'dateFilterType' | 'integrationFilter'
  | 'statusFilter' | 'tagsFilter' | 'assignedUserFilters' | 'undeliveredFilter'
  | 'setUndeliveredFilter' | 'setCurrentFunnelStatus' | 'triggerDirectoryReload'
  | 'setShowArchiveLeadsModal' | 'arePipeFiltersActive' | 'activeFilterCount'
  | 'setSelectedLeadForChatModal' | 'setChatModalIsOpen'
>;

export const PipeModalsSliceContext = createContext<tPipeModalsSlice>(initialState);
const useTreatmentModalsContext = () => useContext(PipeModalsSliceContext);

// Assignment and the kill switch are fixed before the first render. Subscribe
// to just the selected context, so the other context cannot invalidate callers.
export const usePipeModalsContext = getPerfArms().effective.perf_s1 === 'treatment'
  ? useTreatmentModalsContext
  : useModalsContext;
